import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IProvisionOfUnpaidCare {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllUsualResidents?: number | null;
  providesNoCare?: number | null;
  provides1To19Hours?: number | null;
  provides20To49Hours?: number | null;
  provides50OrMoreHours?: number | null;
}

export const defaultValue: Readonly<IProvisionOfUnpaidCare> = {};
